import { planningAPI } from "../../axios";

export const actions = {
    //Planning Template Delivery Unit
    GetPlanningTemplateDeliveryUnit(context, data){
        return planningAPI.get(`PlanningTemplateDeliveryUnit/MainTarget/${data.id}/${data.cycle}`);
    },
    GetSinglePlanningTemplateDeliveryUnit(context, data){
        return planningAPI.get(`PlanningTemplateDeliveryUnit/${data}`);
    },
    UpdatePlanningTemplateDeliveryUnit(context, data){
        return planningAPI.put(`PlanningTemplateDeliveryUnit/Update/${data.id}`, data);
    },
    DeletePlanningTemplateDeliveryUnit(context, data){
        return planningAPI.delete(`PlanningTemplateDeliveryUnit/Remove/${data}`);
    },
    CreatePlanningTemplateDeliveryUnit(context, data){
        return planningAPI.post(`PlanningTemplateDeliveryUnit/Add`, data);
    },
    PostDUTemplate(context, data){
        return planningAPI.post(`PlanningTemplateDeliveryUnit/Post/${data.cycle}/${data.campusId}/${data.planningMainTargetId}`, data.duIds);
    }
}